module.exports = kolibriCoreAppGlobal.utils.i18n;